import { render, staticRenderFns } from "./uploadOnly.vue?vue&type=template&id=742c20d0&scoped=true"
import script from "./uploadOnly.vue?vue&type=script&lang=js"
export * from "./uploadOnly.vue?vue&type=script&lang=js"
import style0 from "./uploadOnly.vue?vue&type=style&index=0&id=742c20d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742c20d0",
  null
  
)

export default component.exports